import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL_EXPENSES = `${config.URL_EXPENSES}/od`;

// 🔹 Función auxiliar para manejar solicitudes HTTP
const request = async (method, endpoint, data = null) => {
  const url = `${BASE_URL_EXPENSES}${endpoint}`;
  try {
    const headers = await headers_get();
    return await axios({ method, url, data, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
    throw error;
  }
};

// 🔹 Gestión de Roles de Conceptos de Gastos
export const expenses_concept_roles_get = async () => request("get", "/expense-concepts/roles");

// 🔹 Gestión de Conceptos de Gastos
export const expenses_concept_get = async () => request("get", "/expense-concepts");
export const expenses_concept_post = async (data) => request("post", "/expense-concepts", data);
export const expenses_concept_put = async (id, data) => request("put", `/expense-concepts/${id}`, data);
export const expenses_concept_delete = async (id) => request("delete", `/expense-concepts/${id}`);

// 🔹 Gestión de Listas de Conceptos de Gastos
export const expenses_concept_list_get = async (id) => request("get", `/expense-concepts/${id}/expense-concepts-list`);
export const expenses_concept_list_post = async (id, data) => request("post", `/expense-concepts/${id}/expense-concepts-list`, data);
export const expenses_concept_list_put = async (id, id2, data) => request("put", `/expense-concepts/${id}/expense-concepts-list/${id2}`, data);
export const expenses_concept_list_delete = async (id, id2) => request("delete", `/expense-concepts/${id}/expense-concepts-list/${id2}`);
